(function(){
  'use strict';

  /* BIN-B UGC video behaviour.
     Removed (CRO audit): fake "sold" counter, fake stock-left bar, fake 3-hour countdown
     that restarted for every visitor, and the random "live viewers" counter. */

  // ── YouTube facade: load iframe only on click (saves ~500KB per video)
  document.querySelectorAll('.binb-yt-card').forEach(function(card){
    var btn = card.querySelector('[data-yt-play]');
    if(!btn) return;
    btn.addEventListener('click', function(){
      var ytId = card.getAttribute('data-yt-id');
      if(!ytId) return;
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + ytId + '?autoplay=1&rel=0&playsinline=1';
      iframe.frameBorder = '0';
      iframe.allow = 'autoplay;encrypted-media;picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:none;';
      card.innerHTML = '';
      card.appendChild(iframe);
      card.classList.add('playing');
    }, {once: true});
  });

  // ── TikTok / Instagram lazy iframes via IntersectionObserver
  if('IntersectionObserver' in window){
    var lazyIframes = document.querySelectorAll('.binb-ugc__card iframe[data-src]');
    var iframeObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting) return;
        var iframe = entry.target;
        iframe.src = iframe.getAttribute('data-src');
        iframe.removeAttribute('data-src');
        iframeObserver.unobserve(iframe);
      });
    }, {rootMargin: '200px'});
    lazyIframes.forEach(function(iframe){ iframeObserver.observe(iframe); });
  } else {
    document.querySelectorAll('.binb-ugc__card iframe[data-src]').forEach(function(iframe){
      iframe.src = iframe.getAttribute('data-src');
    });
  }

  // ── MP4 videos: tap to play / tap to pause, one at a time
  var mp4Cards = [].slice.call(document.querySelectorAll('[data-vid-card]'));
  var allVids  = mp4Cards
    .map(function(c){ return c.querySelector('[data-ugc-video]'); })
    .filter(Boolean);

  function pauseOthers(current){
    allVids.forEach(function(other){
      if(other !== current && !other.paused){ other.pause(); }
    });
  }

  mp4Cards.forEach(function(card){
    var btn = card.querySelector('[data-play-btn]');
    var vid = card.querySelector('[data-ugc-video]');
    if(!vid) return;

    function start(){
      pauseOthers(vid);
      vid.muted = false;
      var p = vid.play();
      if(p && p.catch){
        p.catch(function(){
          vid.muted = true;
          var retry = vid.play();
          if(retry && retry.catch){ retry.catch(function(){}); }
        });
      }
    }

    if(btn){ btn.addEventListener('click', start); }
    vid.addEventListener('click', function(){
      if(vid.paused){ start(); } else { vid.pause(); }
    });
    vid.addEventListener('playing', function(){ card.classList.add('playing'); });
    vid.addEventListener('pause',   function(){ card.classList.remove('playing'); });
    vid.addEventListener('ended',   function(){ card.classList.remove('playing'); });
  });

  // Pause MP4 videos that scroll out of view (saves data on mobile)
  if('IntersectionObserver' in window && allVids.length){
    var vidObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting && !entry.target.paused){ entry.target.pause(); }
      });
    }, {threshold: 0.25});
    allVids.forEach(function(v){ vidObserver.observe(v); });
  }

  // ── Upload tile preview
  var input = document.getElementById('binb-upload-input');
  if(input){
    input.addEventListener('change', function(){
      var file = this.files[0];
      if(!file || !file.type.startsWith('video/')) return;
      var url  = URL.createObjectURL(file);
      var label = input.closest('.binb-ugc__upload');
      var plus  = label && label.querySelector('.binb-upload-plus');
      if(plus) plus.style.display = 'none';
      var prev = document.createElement('video');
      prev.className = 'binb-preview';
      prev.src       = url;
      prev.autoplay  = true;
      prev.muted     = true;
      prev.loop      = true;
      prev.playsInline = true;
      if(label) label.appendChild(prev);
    });
  }

})();
